

























































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {translate} from '@/services/trans'
import {getMargin, getHeaderHeight} from "@/services/margin";

@Component
export default class SwipeBauminatorBLock extends Vue {
  @Prop() isMobileView!: boolean;
  @Prop() topPosition!: number;
  @Prop() blockId!: string;
  @Prop() blockInnerId!: string;
  @Prop() transLine1!: string;
  @Prop() transLine2!: string;
  @Prop() transDescription!: string;
  @Prop() bgColor!: string;
  @Prop() image1Class!: string;
  @Prop() image2Class!: string;
  @Prop() image3Class!: string;

  public c_y = 0
  public c_y2 = 0
  public image_1 = 0
  public image_2 = 0
  public scroll_position = 0
  public textAnimationDelay = -15
  public destopHeight = 0
  public headerHeight = getHeaderHeight()
  public margin = 0

  mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.resize);
    setTimeout(() => {
      this.setMargin();
    }, 300)
  }

  resize(e: any) {
    this.onScroll(e);
    this.setMargin();
  }

  onScroll(e: any) {
    const element: any = document.getElementById(this.blockId)
    let elementTopPosition = element.getBoundingClientRect().top
    const elementInnerHeight = element.clientHeight
    this.c_y = (elementTopPosition / (elementInnerHeight / 100)) * 1.8 * (this.image3Class != '' ? 2: 1) * (this.isMobileView ? 2 : 1)
    this.c_y2 = ( (elementTopPosition / (elementInnerHeight / 100)) * 2.2 ) + (this.isMobileView ? 0 : 50)
    if(this.isMobileView){
      this.image_1 = (elementTopPosition / (elementInnerHeight / 100)) * 3.5 +50
      this.image_2 = (elementTopPosition / (elementInnerHeight / 100)) * 3.5 + 150
    }
    this.scroll_position = (elementTopPosition / (elementInnerHeight / 100)) * 1.8
    if (this.c_y < -101) {
      this.c_y = -100
    }
    if (this.c_y2 < -101) {
      this.c_y2 = -100

    }
    if (this.image_1 < -25) {
      this.image_1 = -25
    }
    if (this.image_2 < -25) {
      this.image_2 = -25
    }
    if(this.scroll_position < -100 && this.downAction){
      this.nextFrom(this.blockId, false)
      this.downAction = false
      this.upAction = true
    }
    if(this.scroll_position > 20 && this.upAction){
      this.nextFrom(this.blockId, true)
      this.downAction = true
      this.upAction = false
    }

    this.setMargin();
  }

  upAction = false
  downAction = true

  setMargin() {
    if(!this.isMobileView){
      this.margin = getMargin(this.blockInnerId, true)
    }else{
      this.margin = getMargin(this.blockInnerId, true)
    }
  }


  trans(key: string) {
    return translate(key)
  }
  @Emit("next")
  nextFrom(name :string, isDown: boolean = false) {}


}
